import * as CounterpartySearchActions from './action';
const initialState = {
    counterpartySearchSuccess: [],
    counterpartySearchFailure: [],
    counterpartyUpdateSuccess: [],
    counterpartyUpdateFailure: [],
    counterpartyMasterUpdateSuccess: [],
    counterpartyMasterUpdateFailure: []    
}

const counterpartySearchComponentReducer = (state = initialState, action) => {
    switch (action.type) {
        case CounterpartySearchActions.COUNTERPARTY_SEARCH_SUCCESS:
            return state = {
                ...state,
                counterpartySearchSuccess: action.data
            }
        case CounterpartySearchActions.COUNTERPARTY_SEARCH_FAILURE:
            return state = {
                ...state,
                counterpartySearchFailure: action.data
            }
        case CounterpartySearchActions.UPDATE_COUNTERPARTY_DATA_SUCCESS:
            return state = {
                ...state,
                counterpartyUpdateSuccess: action.data
            }
        case CounterpartySearchActions.UPDATE_COUNTERPARTY_DATA_FAILURE:
            return state = {
                ...state,
                counterpartyUpdateFailure: action
            }
        case CounterpartySearchActions.UPDATE_COUNTERPARTY_MASTER_DATA_SUCCESS:
            return state = {
                ...state,
                counterpartyMasterUpdateSuccess: action.data
            }
        case CounterpartySearchActions.UPDATE_COUNTERPARTY_MASTER_DATA_FAILURE:
            return state = {
                ...state,
                counterpartyMasterUpdateFailure: action
            }
        default: return state
    }
};

export default counterpartySearchComponentReducer;